import * as yup from "yup";

const taxIdValueSchema = () => yup.string().min(5, "Tax Id must be at least 5 characters");

const taxIdTypeWhenNumberPresent = (numberField: string) =>
  yup.string().when(numberField, {
    is: (value: string | null) => !!value,
    then: (schema) => schema.required("Tax Id Type required"),
  });

export const getSchema = (
  includeRoleValidation: boolean = true,
  isChildOfJointAccount: boolean = false,
  isOnboardingCase: boolean = false,
) =>
  yup.object().shape({
    ownershipPercentage: isChildOfJointAccount
      ? yup.number().nullable()
      : yup.number().when("isOwner", {
          is: true,
          then: (schema) =>
            schema
              .required("Ownership percentage is required if owner is selected")
              .typeError("Ownership percentage must be a number")
              .positive("Ownership percentage must be positive"),
        }),
    ...(isOnboardingCase
      ? {
          identificationType: taxIdTypeWhenNumberPresent("identificationNumber"),
          identificationNumber: taxIdValueSchema(),
        }
      : {
          taxIdType: taxIdTypeWhenNumberPresent("taxId"),
          taxId: taxIdValueSchema(),
        }),
    // Address fields
    streetLine1: yup.string(),
    streetLine2: yup.string(),
    city: yup.string(),
    stateOrProvince: yup.string(),
    country: yup.string().required("Country required"),
    zipCode: yup.string(),
    isOwner: yup.boolean(),
    isController:
      includeRoleValidation && !isChildOfJointAccount
        ? yup
            .boolean()
            .test("at-least-one-role", "At least one role must be selected", function (value) {
              const isOwner = (this.parent as { isOwner?: boolean }).isOwner;
              return isOwner === true || value === true;
            })
        : yup.boolean(),
    // individual required fields
    firstName: yup.string().required("First name required"),
    lastName: yup.string().required("Last name required"),
  });

export const schema = getSchema();
